import { z } from 'zod';
import { ColumnSchema } from '../column';

export const TableSchema = z.object({
    key: z.string(),
    plugin: z.string(),
    source: z.string(),
    columns: z.array(ColumnSchema),
});
